// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HybridEnrollmentResultModelResponse {
    static getAttributeTypeMap() {
        return HybridEnrollmentResultModelResponse.attributeTypeMap;
    }
}
HybridEnrollmentResultModelResponse.discriminator = undefined;
HybridEnrollmentResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "HybridEnrollmentResultModel"
    }
];
//# sourceMappingURL=hybridEnrollmentResultModelResponse.js.map